export default function formatDateToLongForm(dateString: any) {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  const date = new Date(dateString);

  // Format the date part
  const formattedDate = date.toLocaleDateString(undefined, options);

  // Format the time part (24-hour format)
  const formattedTime = date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  // Combine date and time
  return `${formattedDate} at ${formattedTime}`;
}
